/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Portuguese(Brasil) language
 *
 * @file pt-br.js
 * @author Manimaran.S
 */

const ptBr = {
  'popularChannelSlider.allChannels': 'Todos os canais',
  'popularChannelSlider.recommended': 'Recomendado',
  'hero.myetextbook.link': 'eTextbook',
  'hero.myetextbook.text': 'Não é o título certo? Acesse sua biblioteca de',
  'hero.etextfeaturestitle': 'Encontre materiais de estudo em seu eTextbook',
  'hero.etextfeaturesdescription': 'O seu eTextbook vem com materiais de estudo desenvolvidos para ajudar você a ter sucesso. Estude com flashcards e muito mais sem sair do seu eTextbook.',
  'aichat.title1': 'Obtenha ajuda alimentada por AI para tirar qualquer dúvida sobre este eTextbook',
  'aichat.chatDesc1': 'Digite uma pergunta para começar',
  'subscriptiontext.isSubscribed': 'Parte da sua assinatura',
  'subscriptiontext.nonSubscriber': 'Atualize para ter acesso completo',
  'topicConatiner.otherHeader': 'Vídeos e práticas relacionados',
  'topicConatiner.exactLiteHeader': 'Conceitos e práticas relacionados',
  'moremenu.downloadApp': 'Baixe o aplicativo',
  'moremenu.downloadAppAlreadyDownload': '%Click here% para baixar o aplicativo em outro dispositivo e entrar automaticamente ou para usar seu código QR exclusivo para entrar com segurança no aplicativo que você já instalou.',
  'moremenu.downloadAppNotDownload': '%Click here% para baixar o aplicativo e entrar com segurança com seu código QR exclusivo',
  'channel.noBundletitle': 'Use a Preparação para estudos para seus cursos relacionados e outros cursos',
  'onboard.studyPlan': 'Foi criado um plano de estudo personalizado!',
  'onboard.addCourseAnother': 'Você deseja adicionar outro curso?',
  'onboard.purchase': 'Preciso adquirir um eTextbook da Pearson',
  'onboard.addCourseWithoutEtext': 'Adicione um curso usando a Preparação para estudos',
  'onboard.mayBeLater': 'Talvez mais tarde',
  'onboard.aboutCourse': 'Conte para nós sobre seu curso',
  'onboard.close': 'Fechar',
  'course.addTitle': 'Adicionar curso',
  'common.PURCHASE': 'Comprar',
  'common.CLOSE': 'Fechar',
  'open': 'abrir',
  'continue': 'Continuar',
  'yes': 'Sim',
  'no': 'Não',
  'audio': 'Áudio',
  'courses.toc.PUBLISH_SUCCESS': 'Sucesso!',
  'courses.toc.PUBLISH_MESSAGE': 'Os alunos verão as alterações na próxima vez que abrirem o conteúdo.',
  'errors.GENERIC_TITLE': 'Você não tem acesso no momento',
  'errors.GENERIC_DESC': 'Primeiro, atualize a página ou limpe o cache. Se isso não funcionar, entre em contato com o suporte ',
  'errors.GENERIC_LINK': 'da Pearson.',
  'errors.GENERIC_CODE': 'Código do erro: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Assinatura não encontrada',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Sua conta não inclui acesso para este título. Se você acredita que receber esta mensagem tenha\n      sido errado, entre em contato com o Suporte Técnico da Pearson',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Assinatura não encontrada',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Sua assinatura não inclui acesso ao eText, porém você pode assinar agora mesmo utilizando \n    um cartão de crédito.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Minha conta',
  'menu.helpCenter': 'Central de ajuda',
  'menu.preferencesCenter': 'Central de preferências',
  'menu.CONTACT_SUPPORT': 'Entrar em contato com Suporte',
  'menu.HELP_SUPPORT': 'Ajuda e suporte',
  'menu.FAQS': 'Perguntas frequentes',
  'menu.CHAT_WITH_SUPPORT': 'Fale com o suporte',
  'menu.OTP_CODES': 'Códigos OTP',
  'menu.LAUNCH_CODE': 'Iniciar log de código',
  'menu.SEND_CODE': 'Enviar novo código do usuário por e-mail',
  'menu.SEND_CODE_PHONE': 'Enviar novo código do usuário por mensagem de texto',
  'menu.LEGAL': 'Jurídico',
  'menu.PRIVACY_NOTICE': 'Aviso de privacidade',
  'menu.TITLE_INFO': 'Informações do título',
  'menu.PEARSON_ACCESSIBILITY': 'Acessibilidade da Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registre {deviceLimit} dispositivos. Faça uma troca por mês.',
  'menu.ACCESSIBILITY': 'Acessibilidade',
  'menu.ACCESSIBILITY_SUPPORT': 'Apoio à acessibilidade',
  'menu.DEVICES': 'Dispositivos recentes',
  'menu.THIS_DEVICE': 'Este dispositivo',
  'menu.GET_THE_APP_DOWNLOAD': 'Baixar o aplicativo móvel',
  'menu.MOJO_APP_INFO': 'Acesse a loja de aplicativos do seu celular ou tablet para usar o Pearson+ off-line.',
  'menu.DEVICE_LABEL': 'Dispositivo',
  'menu.DEVICE_DISCONNECT': 'Desconectar',
  'menu.FOXIT': 'Distribuído pela Foxit',
  'menu.TERMS_OF_USE': 'Termos de uso',
  'menu.SIGN_OUT': 'Desconectar',
  'menu.PRINT_PAGE': 'Imprimir página',
  'menu.COPY_RIGHT': 'Direito autoral © {year} Pearson Education Inc. Todos os direitos reservados.',
  'print.FOOTER_MESSAGE': 'Impresso por {fullName}({email}) em {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Você já fez a troca este mês',
  'device.SWITCH_DEVICE': 'Mudar para o atual dispositivo?',
  'device.SWITCH_ONCE': 'Como só é possível fazer uma troca por mês, você não poderá desfazer esta ação.',
  'device.SEAT_TAKEN': 'Essa vaga está ocupada',
  'device.DISCONNECT_DEVICE': 'Você só pode fazer login em 3 dispositivos. Para continuar aqui, desconecte outro dispositivo.',
  'device.ALERT_TEXT': 'Lembre-se de que você pode trocar de dispositivos uma vez por mês.',
  'device.DISCONNECT': 'Desconectar',
  'device.CONTINUE': 'Continuar',
  'device.HEADER': 'Deseja encerrar a sessão em seu outro navegador?',
  'device.CLOSE': 'Voltar para a página inicial',
  'device.CODE': 'Continue aqui inserindo o código de autenticação que enviamos para {maskedEmail}. Não está funcionando? Verifique sua pasta de spam, {email}, ou entre em contato com {support}.',
  'device.TIMER': 'Você tem {time} para digitar seu código aqui',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Perguntas frequentes',
  'device.RESEND_NAME': 'Reenviar',
  'device.NOTE': 'Caso use regularmente o Pearson+ em dois lugares, como no trabalho e em casa, lembre-se de sair da sua conta quando terminar. Você também pode usar o aplicativo Pearson+ em até dois dispositivos. Para mais informações, consulte nossas {faq}.',
  'device.NOTE_HEADER': 'Evitar isso da próxima vez',
  'device.CONTACT_SUPPORT': 'atendimento ao cliente',
  'device.CONTACT_EMAIL': 'atualize seu e-mail',
  'device.INCORRECT': 'Incorreto. Verifique novamente o código ou reenvie-o.',
  'device.MANY_ATTEMPTS': 'Várias tentativas. Tente reenviar o código',
  'device.EXPIRED': 'Seu tempo esgotou. Tente reenviar o código',
  'device.ACCESS_HEADER': 'Deu certo!',
  'device.ACCESS_DESC': 'Sua sessão foi autenticada. Gostaria de atualizar sua senha enquanto está logado?',
  'device.ACCESS_CHANGE_PASSWORD': 'Alterar senha',
  'device.ACCESS_RESET_PASSWORD': 'Redefinir senha',
  'device.THREATONE_TITLE': 'Tudo certo?',
  'device.THREATONE_DESC': 'Notamos uma atividade suspeita em sua conta.',
  'device.THREATONE_DESC_TWO': 'Esta é uma boa hora para alterar sua senha.',
  'device.MAY_BE_LATER': 'Talvez mais tarde',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': 'Para manter a segurança, vamos encerrar a sua sessão. Nós enviamos um link de redefinição de senha ao e-mail vinculado à sua conta.',
  'device.ACCOUNT_LOCK_TITLE': 'Notamos uma atividade de phishing em sua conta',
  'device.ACCOUNT_LOCK_TIMER': 'Sie werden abgemeldet in {time}',
  'navigation.PAGE': 'Erro de',
  'launchcode.CREATEBY': 'Criado por:',
  'launchcode.sentvia': 'Enviar por:',
  'launchcode.CODEINLAST': 'Códigos dos últimos 7 dias:',
  'launchcode.TIMESENT': 'Horário de envio:',
  'launchcode.ACCOUNTEMAIL': 'E-mail da conta:',
  'launchcode.LAUNCHDIALOGTITLE': 'Log de código OTP',
  'textmessage.TITLE': 'Inserir o número de telefone',
  'textmessage.PHONE_NUMBER': 'Número de telefone',
  'textmessage.SEND_CODE': 'Enviar código',
  'textmessage.INVALID_NUMBER': 'Número de celular inválido.',
  'textmessage.SUCCESS_MESSAGE': 'Código enviado',
  'remove.title': 'Remover título?',
  'remove.subTitle': 'Você pode recuperar quando quiser. Basta usar a pesquisa para adicionar novamente.',
  'remove.buttonText': 'Remover',
  'search.searchPlaceHolderPPlus': 'Pesquisar por ISBN, título ou autor',
  'search.searchPlaceHolderEText': 'Pesquisar na sua biblioteca',
  'footer.downloadMobileApp': 'Baixar o aplicativo móvel',
  'footer.termsOfUse': 'Termos de uso',
  'footer.privacy': 'Privacidade',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Não venda minhas informações pessoais',
  'footer.accessibility': 'Acessibilidade',
  'footer.patentNotice': 'Aviso de patente',
  'footer.copyrights': 'Pearson Todos os direitos reservados.',
  'hero.toc.defaultPlacehoder': '--- selecione um tópico ---',
  'hero.openEtextBookV1': 'Abrir eTextbook',
  'hero.heroHeading': 'Porque está estudando <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Preparação para estudos',
  'hero.study.help': 'Receba ajuda nos estudos',
  'hero.study.jumpBackIn': 'Voltar',
  'hero.study.numOfUsers': 'No momento, há <b>{num_of_users}</b> alunos usando os canais.',
  'hero.heroChannel.cardsHeading': 'Continue de onde você parou',
  'hero.marketingcard1.copy.title': 'Aprenda com vídeos',
  'hero.marketingcard1.copy.description': 'Assista a vídeos curtos com explicações que explicam tópicos complicados.',
  'hero.marketingcard2.copy.title': 'Problemas práticos',
  'hero.marketingcard2.copy.description': 'Prepare-se para suas provas com milhares de questões semelhantes às da prova e resoluções em vídeo',
  'hero.marketingcard3.copy.title': 'Obtenha ajuda especializada',
  'hero.marketingcard3.copy.description': 'Poste perguntas e obtenha respostas de especialistas',
  'hero.popularTopics.heading': 'Outros tópicos populares neste canal',
  'hero.popularChannels.headingv1': 'Está fazendo outro curso?',
  'hero.popularChannels.descriptionv2': 'Navegue pelos tópicos populares de ajuda de estudo.',
  'hero.practice': 'Praticar',
  'hero.herobook.mappedChannelHeading': 'Ajuda de estudo recomendada neste canal',
  'libraryL2.myBooks': 'Meus livros',
  'libraryL2.archived': 'Arquivado',
  'libraryL2.back': 'Anterior',
  'hero.practiceProblem': 'Problema prático',
  'nativeAppBanner.drawer.title': 'Abrir em...',
  'nativeAppBanner.drawer.pearsonApp': 'Aplicativo Pearson+',
  'nativeAppBanner.banner.title': 'Aplicativo Pearson+',
  'nativeAppBanner.banner.description': 'Aprenda onde estiver',
  'hero.promotionalcard.list1': 'Vídeos curtos que explicam tópicos complicados',
  'hero.promotionalcard.list2': 'Milhares de questões semelhantes às da prova',
  'hero.promotionalcard.list3': 'Obtenha respostas de especialistas',
  'hero.studyandexamprep': 'Preparação para estudos',
  'hero.heroBook.sectionSubHeadingV1': 'Analise tópicos difíceis com explicações em vídeo e questões práticas adaptadas ao seu curso.',
  'hero.heroBook.sectionSubHeadingV2': 'Analise tópicos difíceis com explicações de conceitos e questões práticas adaptadas ao seu curso.',
  'hero.SeeAllStudyOptions': 'Ver todas as opções de estudo',
  'hero.herobook.mappedChannelHeadingV1': 'Vídeos e perguntas práticas recomendados',
  'hero.popularTopics.headingV1': 'Outros tópicos populares',
  'hero.heroHeadingV1': 'Para <span>{replace_value}</span>',
  'hero.learnmore': 'Saiba mais',
  'hero.eTextbook': 'eTextbook',
  'hero.goToPage.label': 'Ir para a página',
  'subscription.studyTitle': 'Preparação para estudos',
  'print.printAvailTitle': 'Deseja imprimir esta página? Veja como.',
  'print.printAvailDesc': 'Em seu eTextbook, selecione o ícone de conta no canto superior direito. Em opções, escolha "Imprimir página" e, em seguida, escolha suas configurações de impressão.',
  'print.printNotAvailTitle': 'A opção de impressão deste eText não está habilitada.',
  'print.printNotAvailDesc': 'Para facilitar o acesso offline, baixe seu título pelo aplicativo Pearson+ e aproveite a flexibilidade de estudar em qualquer lugar e a qualquer hora!',
  'hero.header.cta': 'Ir para as ferramentas de estudo',
  'hero.header.ctav2': 'Abrir Preparação para estudos',
  'hero.marketing.title': 'Encontre seu eTextbook',
  'hero.marketing.subTitle': 'Escolha entre mais de 2000 eTextbooks com áudio, flashcards, anotações e muito mais. Apenas $10,99/mês por um período de 4 meses.',
  'hero.popularchannels.desc': 'Receba ajuda nos estudos para estas matérias importantes',
  'hero.removecourse.title': 'Remover o curso do Painel de Controle?',
  'hero.removecourse.description': 'Sempre que quiser, você pode adicionar esse curso de volta ao seu painel clicando em “Adicionar curso”',
  'hero.removecourse.primaryCtaText': 'Remover',
  'hero.removecourse.secondaryCtaText': 'Cancelar',
  'hero.tableOfContents': 'Índice',
  'hero.search': 'Pesquisar',
  'hero.emptystate.cta': 'Pesquisar eTextbooks',
  'hero.watch_it_again': 'Assista novamente',
  'hero.mondly.learnLang.title': 'Comece a aprender um novo idioma gratuitamente',
  'hero.mondly.subTitle': 'Usuários de eTextbooks da Pearson têm três meses gratuitos no Mondly da Pearson.',
  'hero.mondly.description': 'Most language learning apps only let you learn from English. But it\'s best to learn from your native language, so Mondly allows you to learn from any of our 41 languages.',
  'hero.mondly.startLearningCTA': 'Comece a aprender',
  'hero.mondly.marketing.bestApp': 'Melhor aplicativo',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Aplicativo do ano',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - Vencedor na EMEA em 2017',
  'hero.mondly.marketing.editorChoice': 'Escolha do editor',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Aprenda um idioma',
  'header.menu.moreAtPearson': 'Mais na Pearson',
  'hero.subscriptionStatusTitle2': 'Seus recursos da Pearson+',
  'hero.startStudying': 'Começar a estudar',
  'onboard.studyMaterials': 'Escolha um assunto e criaremos um painel com materiais de estudo personalizados.',
  'hero.myETextbooks': 'Meus eTextbooks',
  'header.continueInTheApp': 'Continuar no aplicativo',
  'hero.learnTxt': 'Aprender',
  'hero.examPrepTxt': 'Preparação para exames',
  'hero.aITutorTxt': 'Tutor de IA',
  'AI.toolTip': 'Tire qualquer dúvida comigo sobre o seu eTextbook',
  'hero.studyExamPrepAllYourCourses': 'Preparação para estudos para todos os seus cursos',
  'header.qrCode.subHeaderTxt': 'Use este código QR para fazer login de forma rápida e segura no aplicativo Pearson+ em seu dispositivo móvel.',
  'header.qrCode.dontHaveApp': 'Não tem o aplicativo?',
  'header.qrCode.footerTxt': 'A leitura desse código redirecionará você para a App Store ou Google Play. Depois que o aplicativo for baixado, leia o código novamente para fazer login.',
  'header.qrCode.errorMsg': 'O código QR não carregou. Feche e tente novamente.',
  'hero.yourETextbook': 'Seu eTextbook',
  'onboard.addCourseWithEtextBundle': 'Adicione um curso usando a Preparação para estudos',
  'onboard.disableTooltipText': 'Todos os cursos de Preparação para estudos foram adicionados!',
  'subscriptionstatus.bundlecta': 'Acesse a Preparação para estudos',
  'subscriptionstatus.nonbundlecta': 'Acesse a Preparação para estudos',
  'channel.genericBundle': 'Use a sua Preparação para estudos para ajudar em seus outros cursos',
  'channel.relatedBundle': 'Também use a sua Preparação para estudos para ajudar em seus outros cursos',
  'onboard.courseAdded': 'Curso adicionado',
  'hero.flashcards': 'Flashcards',
  'relatedChannelCard.title': 'Aprimore seu aprendizado com este recurso relacionado',
  'relatedChannelCard.badgeText': 'Preparação para estudos relacionada',
  'sessionInactivity.title': 'Continua aí?',
  'sessionInactivity.description': 'Sua sessão será encerrada em <b>%TIMER%</b> por inatividade.<br/>Gostaria de permanecer conectado?',
  'sessionInactivity.keepMeSignIn': 'Mantenha-me conectado',
  'sessionInactivity.signOut': 'Desconectar',
  'sessionTimeout.title': 'Sessão expirada',
  'sessionTimeout.description': 'Sua sessão expirou por inatividade.',
  'print.qrCode.header': 'Use este código QR para abrir o aplicativo Pearson+ em seu dispositivo móvel.',
  'print.qrCode.footer': 'A leitura desse código redirecionará você para a App store ou o Google Play. Depois que o aplicativo for instalado, faça login para baixar e acessar seu título.',
  'hero.nestest.title': 'Prepare-se para o exame de certificação docente',
  'hero.nestest.subTitle': 'Os usuários do Pearson+ agora podem acessar cursos preparatórios e testes práticos alinhados aos padrões nacionais para se prepararem para os exames de certificação docente.',
  'hero.channelAI.title': 'Precisa de ajuda? Seu Tutor de IA está aqui para isso.',
  'hero.channelAI.desc': 'Faça uma pergunta e obtenha ajuda passo a passo para a lição de casa, recomendações de estudo e muito mais — ajuda personalizada sempre que você precisar.',
  'hero.channelAI.action': 'Pergunte ao Tutor de IA agora',
  'new': 'Novo!',
  'hero.practice.numOfUsers': 'Esta seção contém <b>{practice_num_of_users}</b> problemas práticos.',
  'hero.practice.cta': 'Praticar agora',
  'hero.practice.title': 'Problema prático',
  'diagnostics.errorMsg': 'O diagnóstico não foi carregado. Feche e tente novamente',
  'qrcode.title': 'Comece a estudar em qualquer lugar',
  'qrcode.subtitle': 'Aprenda em qualquer lugar e a qualquer hora com o aplicativo Pearson+. Baixe agora e desfrute de uma experiência de aprendizagem integrada.',
  'qrcode.detailsv1': 'Com o aplicativo Pearson+, você pode usar este código QR para continuar de onde parou. Pesquise no livro, estude com flashcards, assista a aulas em vídeo e muito mais onde quer que esteja.',
  'qrcode.detailsv2': 'Leia este código QR sempre que quiser fazer login rapidamente e continuar exatamente de onde parou.',
  'qrcode.details': 'Com o aplicativo Pearson+, você pode usar este código QR para continuar de onde parou.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Aprenda em qualquer lugar e a qualquer hora com o aplicativo Pearson+. Baixe agora e desfrute de uma experiência de aprendizagem integrada.',
  'install': 'Install',
  'header.menu.createCourse': 'Novo curso',
  'header.dropdown.courses': 'Cursos',
  'header.dropdown.recentlyViewed': 'Visualizados recentemente',
  'header.dropdown.viewAll': 'Visualizar todos os cursos',
  'aet.courseHeader.inviteStudents': 'Convidar alunos',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Convide alunos a acessar este livro digital copiando o endereço do link ou as instruções abaixo para seu e-mail ou plano de ensino.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Endereço do link',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copiar link',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instruções com o endereço do link',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copiar instruções',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Chegou a hora de acessar {bookTitle} o eTextbook para {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Quando estiver tudo pronto, acesse o livro digital em: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Você precisará entrar com sua conta Pearson existente. Caso não tenha uma conta Pearson, poderá criar uma.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Precisa de ajuda?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Data de início:',
  'aet.courseHeader.endDate': 'Data de término:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Formato:',
  'aet.home.manageroster': 'Gerenciar lista de alunos',
  'aet.home.managegradesync': 'Gerenciar sincronização de aulas',
  'aet.home.copycourse': 'Copiar curso',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': 'Atual',
  'aet.instructorCourse.tabs.past': 'Anterior',
  'aet.instructorCourse.tabs.courseSettings': 'Configurações do curso',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Gerenciar lista de alunos',
  'aet.instructorCourse.currentCourses.title': 'Cursos atuais',
  'aet.instructorCourse.pastCourses.title': 'Cursos anteriores',
  'aet.instructorCourse.createOrCopy.title': 'Criar ou copiar um curso da Pearson eTextbook',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copiar o curso de outro instrutor ou criar um novo',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copiar o curso de outro instrutor',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Insira o ID do curso para encontrar o curso que deseja copiar.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID do curso',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Inserir ID do curso',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Você pesquisou por',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Criar novo curso do catálogo',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Pesquise por título, autor, ISBN ou palavras-chave do assunto.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Pesquisar...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Mostrar mais',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Mostrar menos',
  'aet.instructorCourse.cancel': 'Cancelar',
  'aet.instructorCourse.loading': 'Carregando...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Sincronização de notas',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Gerenciar sincronização de aulas',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nome do curso',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Sem título',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nome da seção',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Sem título',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Instituição',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Instituição é obrigatória',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Algo deu errado. Tente de novo.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Nenhum resultado encontrado',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': 'Data de início do curso',
  'aet.instructorCourse.courseForm.endDateLabel': 'Datas de término do curso',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/aa',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Permitir que outros copiem este curso',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Compartilhe este código com os instrutores que desejam copiar este curso.',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copiar código',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opcional)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'O formulário tem erros de validação',
  'aet.instructorCourse.courseForm.submitContinue': 'Continuar',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Salvando...',
  'aet.instructorCourse.courseForm.submitError': 'Não foi possível criar o seu curso. Tente novamente.',
  'aet.instructorCourse.courseForm.submitEditError': 'Não foi possível salvar suas alterações. Tente novamente.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Salvar alterações',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materiais do curso',
  'aet.instructorCourse.courseForm.resolveError': 'Não foi possível carregar os materiais do curso. Tente novamente.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Última visualização',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Adicionado recentemente',
  'aet.instructorCourse.coursesSort.aToZ': 'A a Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z a A',
  'aet.instructorCourse.manageRoster.column.name': 'Nome',
  'aet.instructorCourse.manageRoster.column.role': 'Função',
  'aet.instructorCourse.manageRoster.column.email': 'E-mail',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Matriculado em {date}',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': 'Aluno',
  'aet.instructorCourse.roster.role.ta': 'PA',
  'aet.instructorCourse.roster.role.instructor': 'Instrutor',
  'aet.instructorCourse.roster.status.active': 'Ativo',
  'aet.instructorCourse.roster.status.inactive': 'Inativo',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Todos os membros',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Alunos ativos',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Alunos inativos',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Professor assistente',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instrutor',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autor(a):',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Data de criação do curso:',
  'aet.instructorCourse.noCoursesFound': 'Nenhum curso encontrado',
  'aet.instructorCourse.backButton': 'Anterior',
  'aet.instructorCourse.selectCourse': 'Selecionar curso',
  'aet.home.linkedToLms': 'Vinculado ao LMS',
  'aet.instructorCourse.courseForm.title.create': 'Criar curso',
  'aet.instructorCourse.courseForm.title.copy': 'Copiar curso',
  'aet.instructorCourse.courseForm.title.edit': 'Informações do curso',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Tarefas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Conteúdo da tarefa',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Prazos de conclusão da tarefa',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Destaques e anotações',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Cor de destaque',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Texto da anotação',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Status compartilhado',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Lista de alunos e envolvimento',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Nomes dos alunos',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Endereços de e-mail',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Matrículas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Conclusão e insights',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Definições',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Dados copiados',
  'aet.studentRoster.manageStudentRosterButton': 'Gerenciar lista de alunos',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Exportar progresso dos alunos',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Matriculado em:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Função:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promover {studentName}?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Como professor(a) assistente, essa pessoa poderá consultar o progresso e o desempenho de todos os alunos desta turma.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Ela também poderá gerenciar alunos e tarefas, porém, não poderá excluir a turma.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promover a professor(a) assistente',
  'aet.home.manageRoster.searchPlaceholder': 'Pesquisar por aluno',
  'aet.home.manageRoster.inactivateButtonLabel': 'Desativar os alunos selecionados',
  'aet.home.manageRoster.FilterLabel': 'Mostrar',
  'aet.home.manageRoster.updatingMessage': 'Atualizando lista de alunos... Isso pode levar alguns minutos.',
  'aet.home.courses.search.searchPlaceHolder': 'Pesquisar seus cursos',
  'aet.courses.emptyStateDescription': 'Comece a montar seu curso escolhendo a opção abaixo.',
  'nativePromoBanner.continueInBrowser': 'Continuar no navegador',
  'globalnav.tooltip.hideNavText': 'Ocultar navegação',
  'globalnav.tooltip.showNavText': 'Mostrar navegação',
  'aet.syllabus.progressTitle': 'Extraindo...',
  'aet.syllabus.progressDesc': 'Aguarde enquanto processamos seu programa de estudos.',
  'aet.syllabus.uploadInputLabel': 'Arraste e solte seus arquivos ou clique para carregá-los',
  'aet.syllabus.uploadSyllabusTabLabel': 'Carregar programa de estudos',
  'aet.syllabus.dateAdjusterTabLabel': 'Ajustador de datas',
  'aet.syllabus.addManuallyTabLabel': 'Adicionar tarefas manualmente',
  'aet.syllabus.addEditLaterText': 'Você sempre poderá adicionar ou editar tarefas mais tarde',
  'aet.syllabus.editAssignmentLabel': 'Editar tarefa',
  'aet.syllabus.addAssignmentLabel': 'Adicionar tarefa',
  'aet.syllabus.assignmentTitleLabel': 'Título da tarefa',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Prazo de conclusão',
  'aet.syllabus.editDueDateLabel': 'Editar prazo de conclusão',
  'aet.syllabus.chaptersCoveredLabel': 'Selecione os capítulos ou seções a serem abordados',
  'aet.syllabus.updateCtaLabel': 'Atualizar tarefa',
  'aet.syllabus.addCtaLabel': 'Adicionar tarefa',
  'aet.syllabus.uploadLabel': 'Enviar',
  'aet.syllabus.confirmLabel': 'Confirmar',
  'aet.syllabus.addContentLabel': 'Adicionar conteúdo',
  'aet.syllabus.addEditContentLabel': 'Adicionar/editar conteúdo',
  'aet.syllabus.notPublishedLabel': 'Não publicada',
  'aet.syllabus.updateDatesLabel': 'Atualizar data',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Seu prazo de conclusão foi atualizado. Revise-o e publique.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'As informações do capítulo/seção foram atualizadas. Revise-as e publique.',
  'aet.syllabus.unassignedCoverageStatus': 'Alguns capítulos ainda não foram atribuídos. Faça isso antes de publicar.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Excluir tarefa?',
  'aet.deleteAssignmentTitleMultiple': 'Excluir tarefas?',
  'aet.deleteAssignmentWarning': 'Esta ação não pode ser desfeita e todas as entregas e dados de aluno associados não ficarão mais visíveis.',
  'aet.deleteAssignmentKeepCTA': 'Manter tarefa',
  'aet.deleteAssignmentDeleteCTA': 'Apagar',
  'aet.assignments.loadingAsset': 'Carregando ativo...',
  'aet.assignments.addToDate': 'Adicionar à data',
  'aet.assignments.previewAsStudent': 'Visualizar como aluno',
  'aet.assignments.questionsAndTopics': 'Perguntas e tópicos',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Concluído',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Prazo de conclusão',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Total de perguntas',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Pergunta {count} de {total}',
  'aet.assignments.publishToStudents': 'Publicar para os alunos',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Adicionar data',
  'aet.doneLabel': 'Concluído',
  'aet.assignments.dueDateLabel': 'Prazo de conclusão da tarefa',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': 'Configuração manual',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Use insights em tempo real para identificar lacunas de aprendizagem e agir com antecedência e confiança.',
  'aet.onboarding.promotion.feature.3': 'Os alunos recebem mais suporte com feedback direcionado e a IA da Pearson integrada.',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': 'Não há tarefas para entregar esta semana.',
  'aet.assignments.progressTitle': 'Progresso',
  'aet.assignments.performanceTitle': 'Confiança',
  'aet.assignments.completionTitle': 'Conclusão',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Adicionar tarefa',
  'aet.assignments.deleteTooltip': 'Excluir tarefas selecionadas',
  'aet.assignments.selectToDeleteLabel': 'Modo selecionar e excluir',
  'aet.assignments.bulkEditTooltip': 'Editar tarefas em massa',
  'aet.assignments.title': 'Tarefas',
  'aet.assignments.assignmentTitle': 'Tarefa',
  'aet.assignments.dueDate': 'Prazo de conclusão',
  'aet.tabular.searchPlaceholder.assignments': 'Pesquisar tarefas',
  'aet.tabular.searchPlaceholder.students': 'Pesquisar alunos',
  'aet.tabular.searchPlaceholder.questions': 'Pesquisar perguntas',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Um ou mais estudantes têm prorrogações do prazo de entrega para todas as tarefas',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Um ou mais estudantes têm prorrogações do prazo de entrega para esta tarefa.',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Um ou mais estudantes receberam prorrogações do prazo de entrega. Procure o ícone de informações para identificar essas tarefas.',
  'aet.home.loading': 'Carregando...',
  'aet.home.errorFetchingAssignments': 'Erro ao buscar tarefas',
  'aet.home.dueThisWeekTitle': 'Prazo para esta semana',
  'aet.home.allCaughtUpTitle': 'Você está com tudo em dia!',
  'aet.home.allCaughtUpDescription': 'Não há tarefas para entregar esta semana.',
  'aet.home.suggestedRemediationTitle': 'Revisão sugerida pela Preparação para estudos',
  'aet.home.noSuggestedRemediationTitle': 'Nenhum material de revisão sugerido',
  'aet.home.noSuggestedRemediationDescription': 'Verifique novamente após a sua próxima tarefa.',
  'aet.home.assignmentIncludesTitle': 'A tarefa inclui',
  'aet.home.sectionsLabel': 'Capítulo(s)',
  'aet.home.questionsCount': '{count} perguntas',
  'aet.home.dueLabel': 'Prazo: {dueDate}',
  'aet.home.due': 'Prazo:',
  'aet.home.progressCompletedLabel': 'Concluído',
  'aet.home.progressCompletedPastDueLabel': 'Concluído em atraso',
  'aet.home.progressInProgressLabel': 'Em andamento',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Não iniciado',
  'aet.home.progressCountOfTotal': '{count} de {total}',
  'aet.home.NotAttemptedLabel': 'Não tentado',
  'aet.home.questionsTotalLabel': 'Total de perguntas',
  'aet.home.progressCompletedOnTimeLabel': 'Completadas no prazo',
  'aet.home.segmentGreatLabel': 'Ótimo',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': 'Precisa de trabalho',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': 'Editar tarefa',
  'aet.home.deleteAssignmentTooltip': 'Excluir tarefa',
  'aet.home.viewDetailsButton': 'Ver detalhes',
  'aet.home.viewAsStudentButton': 'Visualizar como aluno',
  'aet.home.welcomeButtonText': 'Iniciar →',
  'aet.review.emptyStateTitle': 'Nada para revisar',
  'aet.review.emptyStateDescription': 'Verifique novamente após a sua próxima tarefa.',
  'aet.dashboard.tabs.upNext': 'Próximo',
  'aet.dashboard.tabs.welcome': 'Boas vindas',
  'aet.dashboard.tabs.assignments': 'Tarefas',
  'aet.dashboard.tabs.review': 'Revisar',
  'aet.dashboard.tabs.studentRoster': 'Alunos',
  'aet.dashboard.classSchedule': 'Programa de aulas:',
  'aet.syllabus.dueTimeLabel': 'Hora de conclusão',
  'hero.accessEducatorGuides': 'Acessar guias do educador',
  'aet.assignment.save': 'Salvar',
  'aet.assignment.finish': 'Encerrar',
  'aet.assignment.saveAndAdd': 'Salvar e adicionar mais',
  'aet.assignment.delete': 'Apagar',
  'aet.assignment.saveAndClose': 'Salvar e fechar',
  'aet.studentRoster.title': 'Alunos',
  'aet.studentRoster.titlev1': 'Aluno',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Prazos de conclusão',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Padrão',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 dias',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 dias',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 dias',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 semana',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 semana',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Último dia de aula',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} tarefas atualizadas',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'As tarefas com o prazo vencido não puderam ser atualizadas automaticamente. Edite-as uma por uma para definir uma nova data de entrega.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Não foi possível atualizar as datas de entrega',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Todas as tarefas estão com o prazo vencido e não puderam ser atualizadas automaticamente. Edite-as uma por uma para definir uma nova data de entrega.',
  'aet.bulkEdit.bulkSplitInstruction': 'Dividiremos igualmente suas tarefas.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Data de entrega da primeira tarefa',
  'aet.bulkEdit.lastAssignmentDue': 'Data de entrega da última tarefa',
  'aet.bulkEdit.assignmentsDueDays': 'Qual data de entrega pretende definir para as tarefas?',
  'aet.bulkEdit.addEditLaterText': 'Usamos IA para criar as tarefas. Você sempre poderá adicionar ou editar tarefas mais tarde.',
  'aet.bulkEdit.monday': 'Segunda-feira',
  'aet.bulkEdit.tuesday': 'Terça-feira',
  'aet.bulkEdit.wednesday': 'Quarta-feira',
  'aet.bulkEdit.thursday': 'Quinta-feira',
  'aet.bulkEdit.friday': 'Sexta-feira',
  'aet.bulkEdit.saturday': 'Sábado',
  'aet.bulkEdit.sunday': 'Domingo',
  'aet.toast.assignmentCreated.title': 'Tarefa criada!',
  'aet.toast.assignmentCreated.single': 'Ela foi chamada automaticamente de {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} as tarefas foram criadas',
  'aet.toast.assignmentUpdated.title': 'Atualização bem-sucedida.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} foram atualizadas',
  'aet.toast.assignmentUpdated.multiple': '{count} tarefas foram atualizadas',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': 'O conteúdo da tarefa pode ser editado até que os alunos comecem a trabalhar nela.',
  'aet.toast.viewAssignment': 'Ver tarefa',
  'aet.toast.viewAssignments': 'Ver tarefas',
  'aet.welcome.title': 'Seu eTextbook da Pearson está vinculado ao seu curso LMS',
  'aet.welcome.LMSAccounTitle': 'Explore insights',
  'aet.welcome.LMSAccounDescription': 'Veja exatamente em quais tópicos sua turma está tendo dificuldades.',
  'aet.welcome.createAssignmentsTitle': 'Criar tarefas',
  'aet.welcome.createAssignmentsDescription': 'Atribua capítulos manualmente ou carregando seu programa de estudos',
  'aet.welcome.progressViewTitle': 'Acompanhe o desempenho em seu LMS',
  'aet.welcome.progressViewDescription': 'Escolha as configurações de sincronização de notas em seu curso do LMS.',
  'aet.assignmentDetails.noAssignmentFound': 'Não há tarefas',
  'aet.assignments.loadingErrorTitle': 'Não é possível carregar as tarefas no momento',
  'aet.assignments.loadingErrorDescription': 'Tente atualizar ou verifique novamente mais tarde.',
  'aet.assignmentStudentDetails.noDataFound': 'Ainda sem dados',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Nenhum aluno se registrou',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Os alunos entrarão na sua turma à medida que comprarem o eTextbook.',
  'aet.home.editAssignmentTooltipDisabled': 'Não é possível editar: o aluno está fazendo a tarefa',
  'aet.home.deleteAssignmentTooltipDisabled': 'Não é possível excluir: o aluno está fazendo a tarefa',
  'aet.home.StudentDetails.questions': 'Perguntas',
  'aet.home.StudentDetails.attempts': 'Tentativas',
  'aet.home.StudentDetails.comprehension': 'Confiança',
  'hero.titleInfo.tooltip': 'Informações do título',
  'aet.home.publishAssignments': 'Publicar todas as tarefas',
  'aet.assignments.saveScheduleAsDraft': 'Salvar cronograma como rascunho',
  'aet.assignments.reviewBeforePublishAlert': 'Revise e publique suas tarefas para que os alunos possam vê-las.',
  'aet.assignments.copiedCoursePublishAlert': 'Adicione os prazos de conclusão às tarefas copiadas e publique-as para que os alunos possam vê-las.',
  'aet.assignments.allSetPublishAlert': 'Tudo certo? Publique suas tarefas para que fiquem visíveis aos alunos.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Alguns conteúdos são criados usando IA com base em materiais didáticos da Pearson. Embora a Pearson tenha um processo para validar o resultado, a IA generativa ainda pode produzir informações imprecisas sobre pessoas, lugares ou fatos.',
  'aet.home.bulkEditTitle': 'Editar tarefas em massa',
  'aet.home.bulkEditSubtitle': 'Faça alterações em seu programa de estudos e depois carregue-o novamente aqui. Suas tarefas e datas de conclusão serão atualizadas correspondentemente.',
  'aet.home.createAssignmentTitle': 'Criar tarefas',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Incluído em outra tarefa',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Algumas seções estão incluídas em outra tarefa',
  'aet.welcome.welcome.Title': 'Boas vindas!',
  'aet.home.student.roaster.ProgressTitle': 'Conclusão total',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Verifique novamente quando os alunos começarem a tarefa.',
  'aet.home.whatDueThisWeekTitle': 'Confira o que deve entregar esta semana',
  'aet.assignments.edit.errorTitle': '{count} as tarefas contêm erros',
  'aet.assignments.edit.errorSubTitle': 'Tarefas com erros não podem ser publicadas. Edite-as ou corrija os erros antes da publicação.',
  'aet.assignments.edit.publishAnyway': 'Publicar mesmo assim',
  'aet.assignments.edit.editAssignments': 'Editar tarefas',
  'aet.assignments.edit.validationInfoToolTip': 'Editar tarefas para corrigir erros',
  'aet.assignments.error.assignmentCreated.title': 'Todas as tarefas contêm erros',
  'aet.assignments.error.assignmentCreated.description': 'Tarefas com erros não podem ser publicadas. Edite-as ou tente um plano de estudos diferente.',
  'aet.assignments.error.uploadSyllabus': 'Carregar programa de estudos',
  'aet.assignments.error.editAssignments': 'Editar tarefas',
  'aet.mondly.title': 'Idiomas',
  'aet.studentRoster.errorState.title': 'Lista de alunos indisponível',
  'aet.studentRoster.errorState.description': 'Não foi possível carregar sua lista de alunos. Tente atualizar ou verifique novamente mais tarde.',
  'aet.assignments.sectionLabel': 'seções',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'perguntas',
  'aet.assignments.assignmentsLabel': 'tarefas',
  'aet.assignments.performanceProgressBar': 'Barra de progresso de desempenho',
  'aet.assignments.completionProgressBar': 'Barra de progresso de conclusão',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Tem certeza que deseja excluir esta tarefa?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Tem certeza que deseja excluir estas tarefas?',
  'aet.home.nextAssignmentTitle': 'Próxima tarefa',
  'aet.home.courseSettings': 'Configurações do curso',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Recursos do eTextbook Pearson+',
  'aet.home.etextbookInformation': 'Informações sobre o eTextbook',
  'aet.multiple.deleteAssignmentKeepCTA': 'Manter tarefa(s)',
  'aet.syllabus.processingText.header': 'Estamos organizando as leituras atribuídas à sua turma. Aguarde um instante.',
  'aet.syllabus.processingText.uploading': 'Enviando seu documento',
  'aet.syllabus.processingText.activating': 'Ativando componentes de IA',
  'aet.syllabus.processingText.extracting': 'Extraindo as tarefas de leitura',
  'aet.syllabus.processingText.mapping': 'Mapeando o conteúdo do livro',
  'aet.syllabus.processingText.finishing': 'Encerrando',
  'aet.syllabus.uploadErrorMessage': 'Certifique-se de que o seu PDF ou .docx tem menos de 10MB e que a sua conexão de internet é estável',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Nenhuma tarefa de leitura encontrada',
  'aet.syllabus.uploadNoAssignmentsDescription': 'Não foi possível extrair as tarefas de leitura deste arquivo. Você pode adicioná-las manualmente.',
  'aet.syllabus.uploadFailedRetryCTA': 'Tentar novamente',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Verifique se o plano de ensino contém <qualities a syllabus should have for this to work> e tente novamente ou crie as tarefas manualmente.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Criação manual',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Algo deu errado',
  'aet.syllabus.uploadModal.genericFailure.body1': 'Não foi possível enviar e processar o plano de ensino',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Verifique sua conexão e tente novamente ou passe para a criação manual de tarefas.',
  'aet.syllabus.uploadModal.successTotal.title': 'Pronto para revisar',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Pronto para revisar',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Revisar tarefas',
  'aet.syllabus.selectChapterWithQuestions': 'Selecione um capítulo com perguntas.',
  'preferenceSetting.subTitle': 'Essas configurações serão o padrão para todos os alunos deste curso.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interações com IA',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Habilitar a Ferramenta de estudo alimentada por IA e resumos de IA nos resultados de pesquisa',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Exibir recursos de Preparação para estudos relacionados a este livro',
  'aet.syllabus.footer': 'A criação de tarefas é alimentada por IA',
  'aet.dashboard.footerDialogDeatils': 'IA generativa é usada para criar perguntas para tarefas com base nos materiais de ensino da Pearson. Embora a Pearson tenha um processo para validar o resultado, a IA generativa ainda pode produzir informações imprecisas sobre pessoas, lugares ou fatos. IA também é usada para agrupar conteúdo para tarefas, com base no programa de estudos e/ou no cronograma que você fornecer.',
  'aet.review.footer': 'Criado usando IA',
  'aet.footerCard.dismiss': 'Descartar',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'A Preparação para estudos é uma ferramenta adicional de apoio ao aprendizado que fornece aos alunos vídeos e problemas práticos adaptados a este curso.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Poderá ser pedida uma assinatura a alunos cujo plano de acesso não inclua a Preparação para estudos para que possam continuar usando os recursos de Preparação para estudos.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Alunos que já adquiriram a Preparação para estudos não serão afetados por esta configuração.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Saiba mais sobre as vantagens da Preparação para estudos',
  'aet.home.viewCourseId': 'Visualizar ID do curso',
  'aet.home.copy': 'Copiar',
  'aet.home.copied': 'Copiado',
  'aet.home.courseLabel': 'ID do curso:',
  'schoolInfoCard.addUniversity': 'Adicionar escola',
  'schoolInfoCard.title': 'Informações sobre a escola',
  'schoolInfoCard.titleV1': 'Conte para nós sobre seu curso',
  'schoolInfoCard.cta': 'Iniciar',
  'schoolInfoCard.pickInstitution': 'Escolher escola',
  'schoolInfoCard.addUniversityTitle': 'Adicionar sua escola',
  'schoolInfoCard.addUniversitySubtitle': 'Conhecer sua escola e seu curso nos ajuda a recomendar os materiais de estudo mais úteis.',
  'schoolInfoCard.searchPlaceholder': 'Procure sua escola...',
  'schoolInfoCard.skip': 'Pular esta etapa',
  'schoolInfoCard.nextStep': 'Próxima etapa',
  'schoolInfoCard.notInList': 'Minha escola não está na lista',
  'schoolInfoCard.noResults': 'Nenhuma escola corresponde à sua pesquisa',
  'schoolInfoCard.noResultsHeading': 'Não consegue encontrar sua escola?',
  'schoolInfoCard.noResultsInstruction': 'Insira o nome completo abaixo',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nome da escola',
  'schoolInfoCard.addInstitutionLabel': 'Adicionar esta escola',
  'aet.assignments.assignmentTitlePlaceholder': 'Inserir um título',
  'aet.assignments.titleValidation.titleRequired': 'O título da tarefa é necessário.',
  'aet.assignments.titleValidation.titleTooLong': 'O título da tarefa não pode exceder {0} caracteres.',
  'aet.assignments.titleValidation.titleInvalidChar': 'O título da tarefa contém caracteres não suportados.',
  'aet.assignments.titleValidation.titleDuplicate': 'O título da tarefa já existe.',
  'aet.syllabus.timeZoneLabel': 'Fuso horário',
  'aet.review.reviewReadingFromAssignments': 'Leitura de avaliação da tarefa',
  'aet.assignments.chaptersLabel': 'capítulo(s)',
  'menu.myAccount.subTitle': 'Sua instituição será exibida aqui',
  'menu.myAccount.subTitleNotAvailable': 'Você poderá adicionar a instituição aqui a qualquer momento.',
  'schoolInfoCard.toastMessage': 'Universidade salva',
  'aet.review.threeDotMenu.askAI': 'Perguntar à IA',
  'aet.home.suggestedRemediationSubtitle': 'Assista a vídeos relevantes e pratique para dominar os tópicos do curso.',
  'aet.home.laggedQuestionLabel': 'Perguntas sinalizadas',
  'aet.home.correctAnswer': 'Resposta correta',
  'aet.home.incorrectAnswer': 'Resposta incorreta mais comum',
  'aet.home.behaviourTrendsLabel': 'Insights sobre a questão',
  'aet.home.strugglingStudentsLabel': 'Alunos com dificuldades',
  'aet.home.patternsInStudensAiLabel': 'Padrões de uso de IA dos alunos',
  'aet.home.questionLabel': 'Questão',
  'aet.home.studentAskingSimilarQuestions': 'Alunos que fazem perguntas semelhantes',
  'aet.home.assignmentDifficultQuestions': 'Perguntas difíceis',
  'aet.home.behaviorTrends': 'Insights sobre a questão',
  'aet.home.behaviors': 'Indicadores de desempenho',
  'aet.home.mostDifficultTopics': 'Perguntas mais difíceis',
  'aet.home.commentsFromStudentLabel': 'Comentários dos alunos',
  'aet.home.disregard': 'Desconsiderar',
  'aet.home.reportAsInaccurate': 'Comunicar como imprecisa',
  'aet.home.Flagged': 'Sinalizado',
  'aet.home.reportQuestionTitle': 'Comunique problemas sobre uma pergunta',
  'aet.home.reportQuestionLabel': 'O que havia de errado com esta pergunta?',
  'aet.home.showComments': 'Mostrar comentários',
  'aet.home.studentReports': 'relatórios de alunos',
  'aet.home.placeholderText': 'Especifique...',
  'aet.home.reportQuestion.notRelevant': 'Irrelevante',
  'aet.home.reportQuestion.notCorrect': 'Incorreta',
  'aet.home.reportQuestion.unsafe': 'Insegura/nociva',
  'aet.home.reportQuestion.somethingElse': 'Outro',
  'aet.home.StudentDetails.assistedByAI': 'Assistido por IA',
  'aet.home.strugglingStudents.emptyStateTitle': 'Nenhum aluno está com dificuldades no momento',
  'aet.home.strugglingStudents.emptyStateDescription': 'Verifique novamente mais tarde.',
  'aet.home.overallStatus.excelling': 'Desempenho excelente',
  'aet.home.overallStatus.fallingBehind': 'Ficando para trás',
  'aet.home.overallStatus.keepingUp': 'Acompanhando o ritmo',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Mostrar apenas "Perguntas difíceis"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Mostrar apenas "Alunos com dificuldades"',
  'aet.home.viewQuestionInAssignment': 'Ver pergunta na tarefa',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Primeiras tentativas incorretas',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Múltiplas tentativas incorretas',
  'aet.home.insightRisk.lowConfidence': 'Confiança baixa',
  'aet.home.insightRisk.mediumConfidence': 'Confiança média',
  'aet.home.insightRisk.lowEngagement': 'Envolvimento baixo',
  'aet.home.insightRisk.countOfStudents': '{count} de {total} alunos',
  'aet.home.insightRisk.na': 'N/A',
  'aet.home.strugglingStudentsHereLabel': 'Alunos com dificuldades aqui',
  'aet.home.insightRisk.didNotAttempt': 'Não tentou',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'Integração com o LMS',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default ptBr;
